import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applySeoForPath } from "../../../common/seo";

/**
 * Keeps `<head>` in step with the current route.
 *
 * Renders nothing. It lives in the shell rather than in each page so the
 * route table in `src/common/seo.js` stays the single source of truth and
 * a new page can't quietly ship with the previous page's title.
 */
const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeoForPath(pathname);
  }, [pathname]);

  return null;
};

export default RouteSeo;
